/// <amd-module name="VSS/Features/SecurityUI/Roles/RoleAssignment" />
export { IRoleAssignmentProps } from "VSS/Features/SecurityUI/Roles/Components/RoleAssignment.Props";
export * from "./Components/RoleAssignment";
